import { render, staticRenderFns } from "./dialogRequest.vue?vue&type=template&id=51d829d6"
import script from "./dialogRequest.vue?vue&type=script&lang=ts"
export * from "./dialogRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports